<div class="modal-header">
  <h5 class="modal-title d-flex align-items-center gap-2">
    <i class="fal fa-download"></i>
    <ng-container i18n>Export Inquiry Report</ng-container>
  </h5>
  <button (click)="close()" type="button" class="close">
    <i class="far fa-times"></i>
  </button>
</div>
<div class="modal-body">
  <form [formGroup]="form">
    <div class="row">
      <div class="offset-md-2 col-md-8">
        <div class="row">
          <div class="col-md-6">
            <mat-form-field2 class="mat-block">
              <mat-select formControlName="year" i18n-placeholder placeholder="Year" required>
                <mat-option *ngFor="let year of years" [value]="year">{{ year }}</mat-option>
              </mat-select>
              <mat-error *ngIf="form.get('year').touched && form.get('year').hasError('required')">
                <ng-container i18n>Year is required</ng-container>
              </mat-error>
            </mat-form-field2>
          </div>
          <div class="col-md-6">
            <mat-form-field2 class="mat-block">
              <mat-select formControlName="month" i18n-placeholder placeholder="Month" required>
                <mat-option *ngFor="let month of months" [value]="month">{{ month }}</mat-option>
              </mat-select>
              <mat-error *ngIf="form.get('month').touched && form.get('month').hasError('required')">
                <ng-container i18n>Month is required</ng-container>
              </mat-error>
            </mat-form-field2>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <app-rental-select
              i18n-placeholder
              [items]="rentals$ | async"
              [ctrl]="form.get('rentals')"
              placeholder="Select Rental(s)"
            >
            </app-rental-select>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <mat-checkbox formControlName="onlyBooked" i18n>Only Booked</mat-checkbox>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button (click)="close()" type="button" class="btn btn-light">
    <i class="far fa-times"></i> <ng-container i18n>Cancel</ng-container>
  </button>
  <button (click)="download(form)" type="button" class="btn btn-secondary-info create-btn" [disabled]="isExporting">
    <i class="cs-icon cs-icon-download" *ngIf="!isExporting"></i>
    <i class="far fa-spinner fa-spin" *ngIf="isExporting"></i>
    <ng-container i18n>export</ng-container>
  </button>
</div>
